import React from "react";
import bg_img from "../../Assets/Images/LatestOffer_bg.png";

const LatestServiceOffer = () => {
  return (
    <div className="px-4 lg:px-10 py-10">
      <div
        style={{
          backgroundImage: `url(${bg_img})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
        className="rounded-lg"
      >
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 px-6 md:px-10 lg:px-16 py-6 md:py-8">
          {/* Text Section */}
          <div>
            <p className="font-orbitron text-white font-semibold text-lg sm:text-xl md:text-2xl lg:text-[30px] leading-[130%] tracking-[1px] capitalize w-full lg:w-[80%]">
              Get the latest service offers, vehicle care tips, and updates—
              straight to your inbox.
            </p>
          </div>

          {/* Input + Button Section */}
          <div className="flex flex-col items-start lg:items-end">
            <input
              type="text"
              placeholder="your mail address"
              className="font-orbitron font-semibold text-sm sm:text-base md:text-md leading-[130%] tracking-[1px] capitalize border-2 w-full sm:w-[90%] lg:w-[80%] px-3 sm:px-4 py-3 sm:py-4 rounded-md"
            />
            <button
              type="submit"
              className="mt-4 font-quicksand font-semibold text-sm sm:text-base md:text-[16px] leading-[26.89px] capitalize border-2 px-6 sm:px-8 md:px-10 py-3 sm:py-4 bg-[#02081A] text-white rounded-md w-full sm:w-auto"
            >
              Subscribe
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LatestServiceOffer;
